<ng-select
  class="bip-select"
  [items]="items"
  [bindLabel]="bindLabel"
  [bindValue]="bindValue"
  [multiple]="multiple"
  [clearable]="clearable"
  [searchable]="searchable"
  [placeholder]="placeholder"
  [disabled]="disabled"
  [ngModel]="value"
  (ngModelChange)="setValue($event)">
  <ng-template ng-label-tmp let-item="item">
    <ng-container *ngIf="!multiple">
      <ng-container *ngIf="selectedItemTpl; else defaultLabel"
                    [ngTemplateOutlet]="selectedItemTpl"
                    [ngTemplateOutletContext]="{ $implicit: item }">
      </ng-container>
      <ng-template #defaultLabel>
        {{ item?.[bindLabel] ?? item }}
      </ng-template>
    </ng-container>
  </ng-template>


  <ng-template ng-option-tmp let-item="item">
    <ng-container
      *ngIf="optionTpl"
      [ngTemplateOutlet]="optionTpl"
      [ngTemplateOutletContext]="{ $implicit: item }">
    </ng-container>
  </ng-template>



</ng-select>
